import { breakpoint } from '@sketch/global-styles';
import styled, { css } from 'styled-components';
import '../PageLayout/index.js';
import { PageLayout } from '../PageLayout/PageLayout.js';

/**
 * COMPONENTS
 */
const FullPageLayout = styled(PageLayout) `
  width: 100%;
  height: 100%;
  margin: 0;
`;
const Wrapper = styled.div `
  display: flex;
  width: 100%;
  height: 100%;

  /* Force the page to take the maximum of PageLayout */
  flex: 1;
`;
// Left sidebar to show the main navigation:
// We show the sidebar for mobile (hidden by default), for desktop we always
// show the sidebar
const Sidebar = styled.aside(({ theme, isSidebarOpen }) => css `
    display: flex;

    width: ${theme.sidebar.leftWidth}px;

    position: absolute;
    top: 0;
    bottom: 0;
    z-index: ${theme.zIndex[5]}; /* bigger z-index than header */

    background-color: ${theme.colors.background.secondary.B};
    border-right: 1px solid ${theme.colors.border.A};
    border-top-width: 0;
    border-bottom-width: 0;

    transition-timing-function: ease-in-out;
    transition-duration: 0.3s;
    transition-property: transform, opacity;

    will-change: transform; /* Force hardware acceleration */
    transform: ${isSidebarOpen ? 'translateX(0)' : 'translateX(-100%)'};

    opacity: ${({ isSidebarOpen }) => (isSidebarOpen ? 1 : 0)};

    /* For bigger than mobile we always show the sidebar */
    ${breakpoint('sm') `
      position: static;
      opacity: 1;
      transform: none;
      transition: none;
      width: ${theme.sidebar.leftWidth}px;
    `}
  `);
const Content = styled.div.attrs({
    'data-content-scrollable': true,
    tabIndex: -1,
})(({ theme }) => css `
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    background-color: ${theme.colors.background.secondary.A};
    z-index: ${theme.zIndex[2]};

    /* This div gets focus when the <PageLayout /> mounts because is the one
    with scroll, and focusing on this element gives the user the ability to use
    keyboard to scroll up/down, but we don't want any focus style */
    outline: none;
  `);
const ContentContainer = styled.div(({ theme, isSidebarOpen }) => css `
    position: relative;

    display: flex;
    flex: 1 0 auto;
    flex-direction: column;

    transition-timing-function: ease-in-out;
    transition-duration: 0.3s;
    transition-property: transform, opacity;

    transform: ${isSidebarOpen
    ? `translateX(${theme.sidebar.leftWidth}px)`
    : undefined};

    /* Prevent horizontal scrolling when the sidebar is opened */
    overflow-x: ${isSidebarOpen ? 'hidden' : undefined};

    ${breakpoint('sm') `
      transform: none;
      overflow-x: initial;
    `};
  `);

export { Content, ContentContainer, FullPageLayout, Sidebar, Wrapper };
